import { TranslateService } from '@ngx-translate/core';
import { UserService } from './../../base-services/user.service';
import { Tabs2ContainerService } from './../../base-classes/containers/services/tabs2-container.service';
import { BaseDefaultListComponent } from './base-default-list.component';
import { BaseContainerService } from './../../base-classes/containers/services/base-container-service';
import { BaseDataService } from './../../base-services/base-data.service';
import { ActivatedRoute } from '@angular/router';
import { BaseEntity } from './../../base-models/base-entity';
import { BaseListComponent } from './../../base-classes/base-list-component';
import { Component, OnInit, Output, EventEmitter, ComponentFactoryResolver, ViewChild } from '@angular/core';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { ModalService } from '../../base-services/modal.service';
import { DefaultTableComponent } from '../default-table/default-table.component';
import { NotificationService } from '../../base-services/notification-service';
// import { ToastrService } from 'ngx-toastr';
// import { TabsContainerService } from './../../base-classes/containers/services/tabs-container.service';

@Component({
  selector: 'yt-fw-default-list-tabs-in-update',
  templateUrl: './default-list-tabs-in-update.component.html'
})
export class DefaultListTabsInUpdateComponent<T extends BaseEntity> extends BaseDefaultListComponent<T> implements OnInit {

  // constructor(
  //   protected activatedRoute: ActivatedRoute,
  //   protected baseDataService: BaseDataService,
  //   protected tabsContainerService2: Tabs2ContainerService<T>,
  //   // protected tabsContainerService: TabsContainerService<T>,
  //   protected userService: UserService,
  //   protected notificationsService: NotificationsService,
  //   protected translateService: TranslateService,
  //   protected modalService: ModalService,
  //   protected componentFactoryResolver: ComponentFactoryResolver
  // ) {
  //   super(activatedRoute, baseDataService, tabsContainerService2, userService, notificationsService, translateService, modalService, componentFactoryResolver);
  // }

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected tabsContainerService2: Tabs2ContainerService<T>,
    // protected tabsContainerService: TabsContainerService<T>,
    protected userService: UserService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    protected componentFactoryResolver: ComponentFactoryResolver
  ) {
    super(activatedRoute, baseDataService, tabsContainerService2, userService, toastrService, translateService, modalService, componentFactoryResolver);
  }

@ViewChild('detailTable', {static: false}) detailTable : DefaultTableComponent;

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.detailTable) {
        this.detailTable = null;
    }
  }


}
